<template>
    <div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/search/recommend/save')" type="primary" icon="el-icon-plus"
			    size="small" @click="$refs.add.show()">新增关键词</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="序号"></el-table-column>
                <el-table-column prop="name" label="关键词"  show-overflow-tooltip></el-table-column>
				<el-table-column prop="typeStr" label="推荐类型"></el-table-column>
				<el-table-column prop="cityStr" label="展示地区"></el-table-column>
				<el-table-column  label="展示时间" min-width="170">
					<template slot-scope="scope">
					    <p v-if="scope.row.startTime">起:{{scope.row.startTime}}</p>
					    <p v-if="scope.row.endTime">止:{{scope.row.endTime}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="targetStr" label="跳转目标" show-overflow-tooltip></el-table-column>
				<el-table-column prop="sort" label="展示权重(顺序)" min-width="110"></el-table-column>
				<el-table-column prop="displayPositionStr" label="显示位置"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" min-width="150"></el-table-column>
				<el-table-column prop="clickNum" label="点击量"></el-table-column>
				<el-table-column prop="statusStr" label="展示状态"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/search/recommend/save')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row)"
                            >编辑</el-button
                        >
						<el-button
						    v-if="$utils.have('/search/recommend/delete')"
						    type="text"
						    size="small"
						    icon="el-icon-delete"
						    @click="del(scope.row.id)"
						    >删除</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add ref="add" @onUpdate="getDataList()"></add>
    </div>
</template>

<script>
import Add from './components/add.vue'
const defaultParams = {
    pageNo: 1,    
}
export default {
    components:{
        Add
    },
    data() {
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: false, 
            datetimerange:[],
            styleList:[],
            tagList:[]
        };
    },
    mounted(){       
        this.getDataList();
    },
    methods: {
       
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/search/recommend/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑事件
        edit(data){
            this.$refs.add.show(data);
        },
		//删除事件
		del(id){
		    this.$confirm('确定要删除吗?', '提示', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.listLoading = true;
		        this.$request({
		            url: '/search/recommend/delete',
		            method: 'POST',
		            params: {id:id}
		        }).then(res => {
		            const { state, msg } = res.data;
		            if( state == 1 ){
		                this.getDataList();
		            }else{
		                this.$message.error(msg || '请求失败');
		            }
		        }).catch(() => {
		            this.$message.error('请求错误');
		        }).finally(() => {
		            this.listLoading = false;
		        });
		    })
		}
    },
};
</script>
